import { put } from 'redux-saga/effects';
import { Creators } from './action';
import { apiEndPoints } from '../../../services/axios/endPoints';
import { WebService } from '../../../services/axios/webServices';

export function* getMasterChecklistSaga({ payload }) {
  const { page, pageSize, searchParams } = payload;

  try {
    yield put(Creators.getMasterChecklistStart());
    // console.log('filterJson', payload);
    const fullUrl =
      yield `${apiEndPoints.getMasterCheckList}/${page}/${pageSize}`;
    const response = yield WebService.post(fullUrl, {
      SearchFilters: { ...searchParams }
    });
    if (response.status >= 200 && response.status < 300) {
      const { data: bulkList, meta } = response.data;
      // const SpareListData = data;
      // console.log('meta', meta, SpareListData);
      yield put(
        Creators.getMasterChecklistSuccess({
          meta,
          bulkList:
            typeof bulkList === 'string' ? JSON.parse(bulkList) : bulkList || []
        })
      );
    } else {
      throw response;
    }
  } catch (error) {
    console.log({ error });

    let payload;
    if (error && error.response && error.response.status) {
      // add toast notification sysytem here
      switch (error.response.status) {
        case 400:
          payload = {
            error: error.response.data.message
          };
          yield put(Creators.getMasterChecklistFailure(payload));
          break;
        case 401:
          payload = {
            error: 'unAuthorized'
          };
          yield put(Creators.getMasterChecklistFailure(payload));
          break;
        case 500:
          payload = {
            error: 'Somthing went wrong try later'
          };
          yield put(Creators.getMasterChecklistFailure(payload));
          break;
        default:
          payload = {
            error: 'Unable to update. Try again later'
          };
          yield put(Creators.getMasterChecklistFailure(payload));
      }
    } else {
      // for custom error
      payload = {
        error: 'No connection try again Later.'
      };

      yield put(Creators.getMasterChecklistFailure(payload));
    }
  }
}

export function* getRepoChecklistSaga({ payload }) {
  const { page, pageSize, searchParams } = payload;

  try {
    yield put(Creators.getRepoChecklistStart());
    // console.log('filterJson', payload);
    const fullUrl =
      yield `${apiEndPoints.getRepoCheckList}/${page}/${pageSize}`;
    const response = yield WebService.post(fullUrl, {
      SearchFilters: { ...searchParams }
    });
    if (response.status >= 200 && response.status < 300) {
      const { data: bulkList, meta } = response.data;
      // const SpareListData = data;
      // console.log('meta', meta, SpareListData);
      yield put(
        Creators.getRepoChecklistSuccess({
          meta,
          bulkList:
            typeof bulkList === 'string' ? JSON.parse(bulkList) : bulkList || []
        })
      );
    } else {
      throw response;
    }
  } catch (error) {
    console.log({ error });

    let payload;
    if (error && error.response && error.response.status) {
      // add toast notification sysytem here
      switch (error.response.status) {
        case 400:
          payload = {
            error: error.response.data.message
          };
          yield put(Creators.getRepoChecklistFailure(payload));
          break;
        case 401:
          payload = {
            error: 'unAuthorized'
          };
          yield put(Creators.getRepoChecklistFailure(payload));
          break;
        case 500:
          payload = {
            error: 'Somthing went wrong try later'
          };
          yield put(Creators.getRepoChecklistFailure(payload));
          break;
        default:
          payload = {
            error: 'Unable to update. Try again later'
          };
          yield put(Creators.getRepoChecklistFailure(payload));
      }
    } else {
      // for custom error
      payload = {
        error: 'No connection try again Later.'
      };

      yield put(Creators.getRepoChecklistFailure(payload));
    }
  }
}
